import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-ecac8163-8f6e-4d80-aec6-9ad5c9a5b949-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "ec-164a6790-f263-4874-a766-fc1dead9a68d-__Layer_2_1_" }, [
      _createElementVNode("g", { id: "ec-f335da13-8e14-4a16-a204-da05c885e5da-__Layer_1-2" }, [
        _createElementVNode("path", {
          id: "ec-a31e101a-fb31-4bda-8190-e77c51871c43-__format_bold",
          d: "m49.2 34.2c6.5-6.8 6.1-17.6-.7-24-3.1-3-7.3-4.6-11.6-4.6h-20.3c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h3.3v47h-3.3c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h25.3c9.4 0 17-7.7 17-17-.1-6.7-3.8-12.6-9.7-15.4zm-12.3-21.7c5.5 0 10 4.5 10 10s-4.5 10-10 10h-10v-20zm5 47h-15v-20h15c5.5 0 10 4.5 10 10s-4.5 10-10 10z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }